import "lodash";
import "moment";
import "can/construct/";
import StatesAndProvinces from "src/helpers/states-and-provinces/";
import TimeZones from "src/helpers/time-zones/";
import YearQuarters from "src/helpers/year-quarters/";
import EventTypes from "src/helpers/event-types/";
import DrivingExceptions from "src/helpers/driving-exceptions/";
import csvHelper from "src/helpers/csvHelper/";
import ModalHeight from "src/helpers/modal-height/";
import FuelTypes from "src/helpers/fuel-types/";
import SelectorCache from "src/helpers/selector-cache/";
import UserPreferences from "src/helpers/user-preferences/";
import AccountProperties from "src/helpers/account-properties/";
import { errorHandler } from "src/helpers/jqxhr-error/";
import Exports from "src/helpers/exports/";
import Reports from "src/helpers/reports-list/";
import Accounts from "src/helpers/accounts/";
import RemoveDiacritics from "src/helpers/diacritics/";
import { getCachedViewport, viewportCachingCreate, viewportCachingRemove } from "./viewport-caching/viewport-caching";

import _includes from "lodash/includes";

// Initiate namespace
can.Construct("Vistracks.AppConstructor", {}, {});

const servers = [
    "uat.vistracks.com",
    "release.vistracks.com",
    "staging.vistracks.com",
    "staging.hos.vistracks.com"
];

// Create namespace properties
Vistracks.BaseURL = location.origin;

const inServers = _includes(servers, location.host);
Vistracks.Server = inServers ? "staging" : "live";

Vistracks.Modules = {};
Vistracks.Scope = {};
Vistracks.myUser = "";

// Helper Utilities
Vistracks.HelperUtils = {
    maxDate: moment("9999-01-01T00:00:00"),
    statesAndProvinces: StatesAndProvinces.get(),
    states: StatesAndProvinces,
    getTimeZones: TimeZones.getTimeZones(),
    getQuarter: YearQuarters.getQuarter(),
    eventTypes: EventTypes,
    csvHelper: csvHelper,
    drivingExceptions: DrivingExceptions,
    modal: ModalHeight,
    fuelTypes: FuelTypes,
    selectorCache: SelectorCache,
    userPreferences: UserPreferences,
    accountProperties: AccountProperties,
    jqXHR: { errorHandler },
    exports: Exports,
    reports: Reports,
    accounts: Accounts,
    removeDiacritics: RemoveDiacritics,
    viewportCaching: {
        get: getCachedViewport,
        create: viewportCachingCreate,
        remove: viewportCachingRemove
    },

    responseError: function (responseData) {
        "use strict";

        const responseText = JSON.parse(responseData.responseText);

        toastr.error(responseText.message);
    },

    getReasonCodeName: function(reasonCode) {
        if (Cookies.get("preferredLanguage") === "es") {
            return reasonCode.hasOwnProperty("reasonEs") ? reasonCode.reasonEs : reasonCode.reason;
        }

        if (Cookies.get("preferredLanguage") === "fr") {
            return reasonCode.hasOwnProperty("reasonFr") ? reasonCode.reasonFr : reasonCode.reason;
        }

        return reasonCode.reason;
    },

    /**
     * Validate if a string is a valid ASCII character.
     *
     * @return {boolean} true : false
     */
    isACII: function (str) {
        "use strict";

        return /^[\x00-\x7F]*$/.test(str);
    },

    /**
     * [[Description]]
     * @param   {object}   violation [[Description]]
     * @param   {object}   status    [[Description]]
     * @returns {[[Type]]} [[Description]]
     */
    drivingRules: function (violation, status) {
        "use strict";
        var exceptions = null,
            cycle,
            cargo,
            region,
            drivingRuleObj,
            getException;

        // Get the region to determine the type of cycle to be use.
        if (status.hasOwnProperty("region")) {
            region = "USA";

            if (status.region != null) {
                region = status.region;
            }
        }

        // Get exceptions
        if (status.hasOwnProperty("exceptions")) {
            if (!_.isArray(status.exceptions) && status.exceptions) {
                exceptions = status.exceptions.split(",");
            }
        }

        drivingRuleObj = {
            violationName: "",
            violationCode: "",
            violationTooltip: "",
            violationPrintName: ""
        };

        switch (region) {
            case "Canada":
                cycle = can.trim(status.cycleCa);
                cargo = can.trim(status.cargo);
                break;

            default:
                cycle = can.trim(status.cycleUsa);
                cargo = can.trim(status.cargo);
                break;
        }

        switch (violation.violationName) {

            // USA DRIVING RULES
            case "SHIFT_DRIVE_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Texas70Hr7days":
                            switch (String(cargo).toLowerCase()) {
                                case "property":
                                case "passenger":
                                    drivingRuleObj.violationName = "12 Hours";
                                    drivingRuleObj.violationCode = "12";
                                    break;
                            }
                            break;

                        default:
                            switch (String(cargo).toLowerCase()) {
                                case "property":
                                    drivingRuleObj.violationName = "11 Hours";
                                    drivingRuleObj.violationCode = "11";
                                    break;

                                case "passenger":
                                    drivingRuleObj.violationName = "10 Hours";
                                    drivingRuleObj.violationCode = "10";
                                    break;
                            }
                            break;
                    }
                }

                drivingRuleObj.violationTooltip = "Shift Driving Hours";
                drivingRuleObj.violationPrintName = "Shift Driving Hours";
                break;

            case "SHIFT_DUTY_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Texas70Hr7days":
                            switch (String(cargo).toLowerCase()) {
                                case "property":
                                case "passenger":
                                    drivingRuleObj.violationName = "15 Hours";
                                    drivingRuleObj.violationCode = '15';
                                    break;
                            }
                            break;

                        default:
                            switch (String(cargo).toLowerCase()) {
                                case "property":
                                case "passenger":
                                    drivingRuleObj.violationName = "14 Hours";
                                    drivingRuleObj.violationCode = '14';
                                    break;
                            }
                            break;
                    }

                    if (exceptions != undefined &&
                        _.isArray(exceptions) &&
                        exceptions.length > 0 &&
                        String(cargo).toLowerCase() === "property"
                    ) {

                        getException = exceptions.filter(function (exception) {
                            return exception === "DrivingWindow16Hour";
                        });

                        if (getException.toString() === "DrivingWindow16Hour") {
                            drivingRuleObj.violationName = "16 Hours";
                            drivingRuleObj.violationCode = '16';
                        }
                    }
                }

                drivingRuleObj.violationTooltip = "Shift Duty Hours";
                drivingRuleObj.violationPrintName = "Shift Duty Hours";
                break;

            case "DUTY_HOURS_IN_CYCLE":
            case "CYCLE_DUTY_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "US70hr8days":
                            drivingRuleObj.violationName = 'US 70hr 8days';
                            drivingRuleObj.violationCode = '70';
                            break;

                        case "US60hr7days":
                            drivingRuleObj.violationName = 'US 60hr 7days';
                            drivingRuleObj.violationCode = '60';
                            break;

                        case "Texas70Hr7days":
                            drivingRuleObj.violationName = 'Texas 70Hr 7days';
                            drivingRuleObj.violationCode = '70';
                            break;

                        case "Alaska70hr7days":
                            drivingRuleObj.violationName = 'Alaska 70hr 7days';
                            drivingRuleObj.violationCode = '70';
                            break;

                        case "Alaska80hr7days":
                            drivingRuleObj.violationName = 'Alaska 80hr 7days';
                            drivingRuleObj.violationCode = '80';
                            break;

                        case "Alabama60hr7days":
                            drivingRuleObj.violationName = 'Alabama 60hr 7days';
                            drivingRuleObj.violationCode = '60';
                            break;

                        case "Alabama70hr8days":
                            drivingRuleObj.violationName = 'Alabama 70hr 8days';
                            drivingRuleObj.violationCode = '70';
                            break;

                        case "California80hr8days":
                            drivingRuleObj.violationName = 'California 80hr 8days';
                            drivingRuleObj.violationCode = '80';
                            break;
                    }
                }

                drivingRuleObj.violationTooltip = "Cycle Duty Hours";
                drivingRuleObj.violationPrintName = "Cycle Duty Hours";
                break;

            case "DRIVE_HOURS_BEFORE_30_MIN_BREAK":
            case "DRIVE_HOURS_TO_BREAK":
            case "BREAK_DRIVE_HOURS":
                drivingRuleObj.violationName = "Rest Break";
                drivingRuleObj.violationCode = "30";
                drivingRuleObj.violationTooltip = "Driving past 8 hours without a 30 min break";
                drivingRuleObj.violationPrintName = "Driving Hours before break";
                break;

                // CANADA DRIVING RULES
            case "CA_DAILY_DUTY_HOURS":
            case "CAN_DAILY_DUTY_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Canada70hr7daysSouth":
                        case "Canada70hr7daysNorth":
                        case "Canada120hr14daysSouth":
                        case "Canada120hr14daysNorth":
                            drivingRuleObj.violationName = 'CA 14 Daily Duty Hour Violation';
                            drivingRuleObj.violationCode = '14';
                            break;
                    }
                }

                drivingRuleObj.violationTooltip = "CA 14 Daily Duty Hour Violation";
                drivingRuleObj.violationPrintName = "CA 14 Daily Duty Hour Violation";
                break;

            case "CA_SHIFT_DUTY_HOURS":
            case "CAN_SHIFT_DUTY_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Canada70hr7daysSouth":
                        case "Canada120hr14daysSouth":
                            drivingRuleObj.violationName = 'CA 14 Shift Duty Hour Violation';
                            drivingRuleObj.violationCode = '14';
                            drivingRuleObj.violationTooltip = "CA 14 Shift Duty Hour Violation";
                            drivingRuleObj.violationPrintName = "CA 14 Shift Duty Hour Violation";
                            break;

                        case "Canada70hr7daysNorth":
                        case "Canada120hr14daysNorth":
                            drivingRuleObj.violationName = 'CA 18 Shift Duty Hour Violation';
                            drivingRuleObj.violationCode = '18';
                            drivingRuleObj.violationTooltip = "CA 18 Shift Duty Hour Violation";
                            drivingRuleObj.violationPrintName = "CA 18 Shift Duty Hour Violation";
                            break;
                    }
                }
                break;

            case "CA_SHIFT_SPAN_HOURS":
            case "CAN_SHIFT_SPAN_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Canada70hr7daysSouth":
                        case "Canada120hr14daysSouth":
                            drivingRuleObj.violationName = 'CA 16 Shift Duty Hour Violation';
                            drivingRuleObj.violationCode = '16';
                            drivingRuleObj.violationTooltip = "CA 16 Shift Duty Hour Violation";
                            drivingRuleObj.violationPrintName = "CA 16 Shift Duty Hour Violation";
                            break;

                        case "Canada70hr7daysNorth":
                        case "Canada120hr14daysNorth":
                            drivingRuleObj.violationName = 'CA 20 Shift Duty Hour Violation';
                            drivingRuleObj.violationCode = '20';
                            drivingRuleObj.violationTooltip = "CA 20 Shift Duty Hour Violation";
                            drivingRuleObj.violationPrintName = "CA 20 Shift Duty Hour Violation";
                            break;
                    }
                }
                break;

            case "CA_SHIFT_DRIVE_HOURS":
            case "CAN_SHIFT_DRIVE_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Canada70hr7daysSouth":
                        case "Canada120hr14daysSouth":
                            drivingRuleObj.violationName = 'CA 13 Shift Driving Hour Violation';
                            drivingRuleObj.violationCode = '13';
                            drivingRuleObj.violationTooltip = "CA 13 Shift Driving Hour Violation";
                            drivingRuleObj.violationPrintName = "CA 13 Shift Driving Hour Violation";
                            break;

                        case "Canada70hr7daysNorth":
                        case "Canada120hr14daysNorth":
                            drivingRuleObj.violationName = 'CA 15 Shift Driving Hour Violation';
                            drivingRuleObj.violationCode = '15';
                            drivingRuleObj.violationTooltip = "CA 15 Shift Driving Hour Violation";
                            drivingRuleObj.violationPrintName = "CA 15 Shift Driving Hour Violation";
                            break;
                    }
                }
                break;

            case "CA_DAILY_DRIVE_HOURS":
            case "CAN_DAILY_DRIVE_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Canada70hr7daysSouth":
                        case "Canada120hr14daysSouth":
                        case "Canada70hr7daysNorth":
                        case "Canada120hr14daysNorth":
                            drivingRuleObj.violationName = 'CA 13 Daily Driving Hour Violation';
                            drivingRuleObj.violationCode = '13';
                            break;
                    }
                }

                drivingRuleObj.violationTooltip = "CA 13 Daily Driving Hour Violation";
                drivingRuleObj.violationPrintName = "CA 13 Daily Driving Hour Violation";
                break;

            case "CYCLE_DUTY_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Canada70hr7daysSouth":
                        case "Canada70hr7daysNorth":
                            drivingRuleObj.violationName = 'CA 70 Cycle Duty Hour Violation';
                            drivingRuleObj.violationCode = '70';
                            drivingRuleObj.violationTooltip = "CA 70 Cycle Duty Hour Violation";
                            drivingRuleObj.violationPrintName = "CA 70 Cycle Duty Hour Violation";
                            break;

                        case "Canada120hr14daysSouth":
                        case "Canada120hr14daysNorth":
                            drivingRuleObj.violationName = 'CA 120 Cycle Duty Hour Violation';
                            drivingRuleObj.violationCode = '120';
                            drivingRuleObj.violationTooltip = "CA 120 Cycle Duty Hour Violation";
                            drivingRuleObj.violationPrintName = "CA 120 Cycle Duty Hour Violation";
                            break;
                    }
                }
                break;

            case "CA_DAILY_OFF_DUTY_HOURS":
            case "CAN_DAILY_OFF_DUTY_HOURS":
                if (cycle !== null) {
                    switch (cycle) {
                        case "Canada70hr7daysSouth":
                        case "Canada70hr7daysNorth":
                        case "Canada120hr14daysSouth":
                        case "Canada120hr14daysNorth":
                            drivingRuleObj.violationName = 'CA 10 Daily Off Duty Hour Violation';
                            drivingRuleObj.violationCode = '10';
                            break;
                    }
                }

                drivingRuleObj.violationTooltip = "CA 10 Daily Off Duty Hour Violation";
                drivingRuleObj.violationPrintName = "CA 10 Daily Off Duty Hour Violation";
                break;
        }

        return drivingRuleObj;
    },

    /**
     * Returns a driving rule violation color code based region parameter
     * @param  {Object} daily A certain driver daily log(s)
     * @return {Object}       Violation color
     */
    violationColor: function (region, violation) {
        "use strict";
        var drivingRule = {

            // Violation code wrap in badges
            violationsColor: "",

            // Violation color in print button
            colorStyle: "",

            // Gridchart violation line class
            polylineClass: ""
        };

        region = region || "USA";

        if ( violation && violation.drivingRuleType ) {
            if ( _.startsWith( violation.drivingRuleType, 'CA' ) || _.startsWith( violation.drivingRuleType, 'ALBERTA' ) ) {
                region = "Canada";
            } else {
                region = "USA";
            }
        }

        switch (region) {
            case "Canada":
                drivingRule.violationsColor = "background-color: #ff8f00;";
                drivingRule.colorStyle = "color: #ff8f00 !important;";
                drivingRule.polylineClass = "ember";
                break;

            default:
                drivingRule.violationsColor = "background-color: #dd4436;";
                drivingRule.colorStyle = "color: #dd4436 !important;";
                drivingRule.polylineClass = "red";
                break;

                // No default
        }

        return drivingRule;
    },

    /**
     * Create a visual representation of a driving violation
     * @param  {Array} data Violation data
     * @return {Array} The visual representation of a driving violation
     */
    drivingViolationsCode: function (violations, status) {
        "use strict";
        var self = this,
            violationsCode = [],
            regionColorCode = null,
            oldViolations;

        _(violations).forEach(itemValue => {
            if (itemValue.hasOwnProperty("iconLabel") && itemValue.iconLabel !== "") {
                regionColorCode = self.violationColor(status.region, { drivingRuleType: itemValue.violationName });
                violationsCode.push(
                    '<a href="javascript://" id="driving-violation" data-placement="left"' +
                    'data-toggle="tooltip" title="' + itemValue.toolTipText + '" style="margin: 0 1px;">' +
                    '<span class="badge" style="' + regionColorCode.violationsColor + '">' + itemValue.iconLabel + '</span>' +
                    '</a>'
                );
            } else {
                oldViolations = self.drivingRules(itemValue, status);
                regionColorCode = self.violationColor(status.region);

                violationsCode.push(
                    '<a href="javascript://" id="driving-violation" data-placement="left"' +
                    'data-toggle="tooltip" title="' + oldViolations.violationTooltip + '" style="margin: 0 1px;">' +
                    '<span class="badge" style="' + regionColorCode.violationsColor + '">' + oldViolations.violationCode + '</span>' +
                    '</a>'
                );
            }
        });

        return violationsCode;
    },

    /**
     * Create a visual representation of a driving violation
     * @param  {Array} data Violation data
     * @return {Array} The visual representation of a driving violation
     */
    drivingViolationsCodeForPrint: function (violations, status) {
        "use strict";
        var self = this,
            violationsCode = [],
            regionColorCode = null,
            oldViolations;

        _(violations).forEach(itemValue => {
            if (itemValue.hasOwnProperty("iconLabel") && itemValue.iconLabel !== "") {
                regionColorCode = self.violationColor(status.region);
                violationsCode.push(itemValue.iconLabel);
            } else {
                oldViolations = self.drivingRules(itemValue, status);
                regionColorCode = self.violationColor(status.region);

                violationsCode.push(itemValue.iconLabel);
            }
        });

        return violationsCode;
    },

    /**
     * Returns a driving violation's code and its full description
     * @param  {Array} violations Driving violations of a certain driver
     * @return {String} Driving violation's code and its full description
     */
    drivingViolationCodeDescription: function (violations, status) {
        "use strict";
        var description = [],
            oldViolations;

        _(violations).forEach(function (itemValue) {
            if (itemValue.hasOwnProperty("iconLabel") && itemValue.iconLabel !== "") {
                description.push(itemValue.iconLabel + ' (' + itemValue.toolTipText + ')');
            } else {
                oldViolations = this.drivingRules(itemValue, violations);
                description.push(oldViolations.violationTooltip);
            }
        });

        return description.join(" ");
    },

    /**
     * Returns a military time
     * @param  {String} param A time to be converted to military time
     * @return {String}       A time in military format
     */
    toMilitaryTime: function (param) {
        "use strict";
        var time = param.split(" : "),
            hours = Number(time[0]),
            minutes = Number(time[1]),
            AMPM = time[2],
            sHours,
            sMinutes;

        if (AMPM === "PM" && hours < 12) {
            hours = hours + 12;
        }

        if (AMPM === "AM" && hours === 12) {
            hours = hours - 12;
        }

        sHours = hours.toString();
        sMinutes = minutes.toString();

        if (hours < 10) {
            sHours = "0" + sHours;
        }

        if (minutes < 10) {
            sMinutes = "0" + sMinutes;
        }

        return sHours + ":" + sMinutes;
    },

    /**
     * Limit the number of input characters.
     * @param {Object} $el   A particular element.
     * @param {Number} limit Character limit input including white space.
     */
    limiter: function ($el, limit) {
        "use strict";
        var charCounter = function charCounter(src) {
            let chars = src.value.length;
            if (chars > limit) {
                src.value = src.value.substr(0, limit);
                chars = limit;
            }
        };

        $el.on("keyup", function () {
            charCounter(this);
        });

        charCounter($el[0]);
    },

    /**
     * Returns a generated Universally Unique Identifier (UUID)
     * @returns {String} The generated UUID
     */
    generateUUID: function () {
        "use strict";
        var d = new Date().getTime(),
            uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                let r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
            });

        return uuid;
    },

    /**
     * Return the converted the datetime string format like `MM/DD/YYYY` to ISO 8601 datetime standard
     * @param  {String} datetime Datetime string in `MM/DD/YYYY` format
     * @return {String} The datetime in ISO 8601 standard format `YYYY-MM-DD`
     */
    toISO8601DateTimeStandard: function (datetime) {
        "use strict";
        var dateTime = datetime.replace(/\//g, "-").split("-");
        return dateTime[2] + '-' + dateTime[0] + '-' + dateTime[1];
    },

    /**
     * Generates a font icon for reason code
     * @param  {Object} params An object contains driver-edited status and its reason code(s)
     * @return {String}   Returns the generated font icon or an empty string
     */
    reasonCodeIcon: function (params) {
        "use strict";

        const { reasonCode, mode, driverEdit, showAllEdits, editReasonCodes } = params;

        const reasonText = (reasonCode) ? reasonCode.replace(/\"/g, "") : "Edited on the App",
            _mode = mode || "";

        const _reasonCode = _.filter(editReasonCodes, { reason: reasonText })[0];
        const title = (_reasonCode) ? _reasonCode.label : reasonText;

        // Remove an asterisk when the mode is on "AOBRD" except if `Show Edits` options is check.
        // Also remove asterisk if there is no reason code.
        if (((driverEdit && _mode === "ELD") || (driverEdit && showAllEdits)) && reasonCode) {
            return `<i class="fa fa-asterisk driver-edit driver-edit-reason col-blue"
                style="position: relative; top: -2px; left: 4px;"
                title="${title}"></i>`;
        }

        return "";
    },

    /**
     * Returns a color coded event status.
     * @param   {String} status       Event status
     * @param   {String} recordStatus Reason code (Optional)
     * @returns {String} Color coded event status
     */
    eventStatus: function (params) {
        "use strict";

        const { duty, recordStatus, reasonCodeIcon } = params;

        let manualPerfix = "";

        if ("manualPrefix" in params) {
            manualPerfix = params.manualPerfix;
        }

        let abbreviation = "",
            eventStatus;

        if (recordStatus) {
            abbreviation = `/${this.inactiveStatus(recordStatus).abbv}`;
        }

        const eventType = this.eventTypes(duty).list();
        const statusTranslated = Locale.translate(eventType);

        switch (eventType) {
            case "OffDuty":
                eventStatus = `<span
                        class="label label-status label-status-off-duty"
                        style="position: relative"
                    >${reasonCodeIcon} ${statusTranslated}${abbreviation}</span>`;
                break;

            case "Sleeper":
                eventStatus = `<span
                        class="label label-status label-status-sleeper"
                        style="position: relative"
                    >${reasonCodeIcon} ${statusTranslated}${abbreviation}</span>`;
                break;

            case "Driving":
                eventStatus = `<span
                        class="label label-status label-status-driving"
                        style="position: relative"
                    >${reasonCodeIcon} ${statusTranslated}${abbreviation}</span>`;
                break;

            case "OnDuty":
                eventStatus = `<span
                        class="label label-status label-status-on-duty"
                        style="position: relative"
                    >${reasonCodeIcon} ${statusTranslated}${abbreviation}</span>`;
                break;

            case "Remark":
                eventStatus = `<span
                        class="label label-status label-status-remark"
                        style="position: relative"
                    >${reasonCodeIcon} ${statusTranslated}${abbreviation}</span>`;
                break;

            case "WaitingAtSite":
                eventStatus = `<span
                        class="label label-status label-status-waiting-at-site"
                        style="position: relative"
                    >${reasonCodeIcon} ${statusTranslated}${abbreviation}</span>`;
                break;

            case "Carrier Change":
                eventStatus = `<span
                        class="label label-status label-status-carrier-change"
                        style="position: relative"
                    >${reasonCodeIcon} ${statusTranslated}${abbreviation}</span>`;
                break;

            default:
                eventStatus = `<span
                        class="label label-status label-status-default"
                        style="position: relative"
                    >${reasonCodeIcon} ${statusTranslated}${abbreviation}</span>`;
                break;
        }

        return eventStatus;
    },

    /**
     * Returns odometer unit based on `userpreference` API data.
     * @param  {Object} params ds: The user preferences data source. id: The user identification number
     * @return {String}        Odometer unit Miles/Km
     */
    getOdometerUnit: function (params) {
        "use strict";
        var unit = _.filter(params.ds, {
            "userId": params.id,
            "key": "UNIT_OF_DISTANCE"
        })[0];

        return (unit) ? unit.stringVal : "MILES";
    },

    /**
     * Convert odometer value to Kilometers (Km) unit.
     * @param  {Float} value       Odometer.
     * @param  {String} currentUnit The current unit measure.
     * @return {Number}             Coverted odometer value.
     */
    convertValueToKm: function (value, currentUnit, precision) {
        "use strict";

        precision = precision === undefined ? 0 : precision;

        const MILES_TO_KM = 1.609344;
        var convertedValue = _.round(value * MILES_TO_KM, precision);

        if (currentUnit === "KILOMETERS") {
            convertedValue = _.round(value, precision);
        }

        return convertedValue;
    },

    /**
     * Convert odometer value to Kilometers (Km) unit.
     * @param  {Float} value       Odometer.
     * @param  {String} currentUnit The current unit measure.
     * @return {Number}             Coverted odometer value.
     */
    convertValueToMi: function (value, currentUnit, precision) {
        "use strict";

        precision = precision === undefined ? 0 : precision;

        const KM_TO_MILES = 0.621371192;
        var convertedValue = _.round(value * KM_TO_MILES, precision);

        return convertedValue;
    },

    convertValueToMi5Precision: function (value, currentUnit) {
        "use strict";
        const KM_TO_MILES = 0.621371192;
        var convertedValue = _.round(value * KM_TO_MILES, 5);

        return convertedValue;
    },

    /**
     * Returns the converted odometer rounded off to the nearest number.
     * @param  {Object} params ds: The user preferences data source. id: The
     * user identification number odometer: The odometer value. currentUnit: The
     * current unit is `KILOMETERS`.
     * @return {Number}        The converted odometer rounded off to the nearest
     * number.
     */
    convertValueToUnit: function (params, precision) {
        "use strict";

        precision = precision === undefined ? 0 : precision;

        const MILES_TO_KM = 1.609344;
        var odometer = parseFloat(params.odometer),
            convertedValue = odometer,

            unit = this.getOdometerUnit({
                ds: params.ds,
                id: params.id
            });

        switch (unit) {
            case "MILES":
                convertedValue = _.round(odometer / MILES_TO_KM, precision);
                break;
            case "KILOMETERS":
                convertedValue = this.convertValueToKm(odometer, params.currentUnit, precision);
                break;
                // No default
        }

        // return ( params.currentUnit === unit ) ?
        //     _.round( odometer ) : _.round( convertedValue );
        return (params.currentUnit === unit) ?
            parseFloat(odometer.toFixed(5)) : parseFloat(convertedValue.toFixed(5));
    },

    /**
     * Returns a particular record status type. It can be `InactiveChanged`,
     * `InactiveChangeRequested`, `InactiveChangeRejected` and `Active`.
     * @param  {String} drivingStatus Event type.
     * @return {String}               Record status type
     */
    inactiveStatus: function (recordStatus) {
        "use strict";
        var status = {};

        switch (recordStatus) {
            case "InactiveChanged":
                status.abbv = "IC";
                status.name = "Inactive Changed";
                status.status = true;
                break;

            case "InactiveChangeRequested":
                status.abbv = "ICR";
                status.name = "Inactive Change Requested";
                status.status = true;
                break;

            case "InactiveChangeRejected":
                status.abbv = "ICJ";
                status.name = "Inactive Change Rejected";
                status.status = true;
                break;

            default:
                status.abbv = "";
                status.name = "Active";
                status.status = false;
                break;
        }

        return status;
    },

    /**
     * Returns a converted milliseconds to time in string format
     * @param  {String} s milliseconds
     * @return {String}   Time
     */
    millisToTime: function (s, hideseconds) {
        hideseconds = hideseconds || false;

        // If seconds contains a negative value then return it as zero.
        if ( s < 0 ) {
            return (!hideseconds) ? "00:00:00" : "00:00";
        }

        var ms, sec, min, hr,
            addZ = function( n ) {
                return (n < 10 ? "0" : "") + n;
            };

        ms = s % 1000;
        s = (s - ms) / 1000;
        sec = s % 60;
        s = (s - sec) / 60;
        min = s % 60;
        hr = (s - min) / 60;

        return (!hideseconds) ? addZ(hr) + ':' + addZ(min) + ':' + addZ(sec) : addZ(hr) + ':' + addZ(min);
    },

    /**
     * Returns a certain driving event like: Yard Moves (YM), Personal Conveyance (PC), Clear YM or PC.
     * @param  {string} status The driving event status
     * @return {object}        Driving event
     */
    drivingEventIndication: function (status) {
        var event = {};

        switch (status) {
            case "YM":
            case "YardMoves":
                event.stroke = "3,3";
                event.eventStatus = 'OnDuty';
                event.color = 'orange';
                event.status = true;
                break;
            case "PC":
            case "PersonalConveyance":
            case "PersonalUse":
                event.stroke = "8,3";
                event.eventStatus = 'OffDuty';
                event.color = 'orange';
                event.status = true;
                break;
            case "ClearYM":
            case "ClearPU":
                event.eventStatus = 'OffDuty';
                event.stroke = "0,0";
                event.color = 'green';
                event.status = true;
                break;
            default:
                event.stroke = "0,0";
                event.color = 'green';
                event.status = false;
        }

        return event;
    },

    /**
     * This will get the previous event based on the dateTime provided
     *
     * @return the event object or false if empty
     */

    getPreviousHistory: function( dateTime, historyLogs ) {
        // sort histories by event time
        var historyByTime = _.filter( _.sortBy( historyLogs, o => moment( o.eventTime ).valueOf() ), ( item ) => item.recordStatus === "Active" ),
            i = 0,
            timeStamp = moment( dateTime );

        _.forEach( historyByTime, ( item, key ) => {
            if ( !moment( item.eventTime ).isAfter( timeStamp ) ) {
                i = key;
            }
        });

        if ( historyByTime.length > 0 && historyByTime[ i ] && moment( historyByTime[ i ].eventTime ).isBefore( timeStamp ) ) {
            return historyByTime[ i ];
        }

        return false;
    },

    /**
     * Get the CanLocalNoLog exception span time data.
     * @param {moment} eventTime Begin time of the day.
     * @param {Array} driverHistoryLogs Collection of driver history logs.
     * @returns Collection of `CanLocalNoLog` span time data.
     */
    getCanLocalNoLogEventsWithin160km: function (eventTime, driverHistoryLogs = []) {
        let spanTime = {
            start: eventTime.toISOString(),
            end: eventTime.clone().endOf("day").toISOString()
        };
        const canLocalNoLogSpanTimeData = [];

        const histories = driverHistoryLogs.filter(h => {
            return (h.eventType === "AddedExceptionRemark" && h.note.includes("CanLocalNoLog")) ||
                (h.eventType === "RemovedExceptionRemark" && h.note.includes("CanLocalNoLog"));
        });

        if (histories.length === 1 && histories[0].eventType === "RemovedExceptionRemark") {
            canLocalNoLogSpanTimeData.push({
                ...spanTime,
                end: histories[0].eventTime
            });
        }

        histories.forEach((history, i) => {
            if (history.eventType === "AddedExceptionRemark" && histories[i + 1]) {
                canLocalNoLogSpanTimeData.push({
                    ...spanTime,
                    start: history.eventTime,
                    end: histories[i + 1].eventTime
                });
            } else if (history.eventType === "AddedExceptionRemark" && histories[i + 1] === undefined) {
                canLocalNoLogSpanTimeData.push({
                    ...spanTime,
                    start: history.eventTime,
                });
            }
        });

        return canLocalNoLogSpanTimeData;
    },

    /**
     * Get the shortHaulNoLog exception span time data.
     * @param {moment} eventTime Begin time of the day.
     * @param {Array} driverHistoryLogs Collection of driver history logs.
     * @returns Collection of `CanLocalNoLog` span time data.
     */
    getShortHaulNoLog: function (eventTime, driverHistoryLogs = []) {
        let spanTime = {
            start: eventTime.toISOString(),
            end: eventTime.clone().endOf("day").toISOString()
        };
        const shortHaulNoLogTimeData = [];

        const histories = driverHistoryLogs.filter(h => {
            return (h.eventType === "AddedExceptionRemark" && h.note.includes("ShortHaulNoLog")) ||
                (h.eventType === "RemovedExceptionRemark" && h.note.includes("ShortHaulNoLog"));
        });

        if (histories.length === 1 && histories[0].eventType === "RemovedExceptionRemark") {
            shortHaulNoLogTimeData.push({
                ...spanTime,
                end: histories[0].eventTime
            });
        }

        histories.forEach((history, i) => {
            if (history.eventType === "AddedExceptionRemark" && histories[i + 1]) {
                shortHaulNoLogTimeData.push({
                    ...spanTime,
                    start: history.eventTime,
                    end: histories[i + 1].eventTime
                });
            } else if (history.eventType === "AddedExceptionRemark" && histories[i + 1] === undefined) {
                shortHaulNoLogTimeData.push({
                    ...spanTime,
                    start: history.eventTime,
                });
            }
        });

        return shortHaulNoLogTimeData;
    },

    /**
     * This will determine if the history event to create/update is in the middle of
     * auto driving event.
     *
     * @return Whether the history event to create/update is in the middle of auto driving event
     */
    isBetweenAutoDriving: function(dateTime, historyLogs) {
        const _this = this;

        let autoDrivingEndTimestamp = null;
        let isBetweenAutoDrivingEvent = false;

        const isCalculationType = function (history) {
            return (
                history.recordStatus === "Active" &&
                _this.eventTypes(history.eventType).drivingEvents()
            );
        };

        // get the index of the first previous occurrence driving event history based on the date and time selected
        const findHistoryBegin = function (timeStamp, logs) {
            let i = 0;

            _.forEach(logs, (item, key) => {
                const eventTimeIsNotAfterEditLogEventTime = !moment(
                    item.eventTime
                ).isAfter(timeStamp);

                if (
                    eventTimeIsNotAfterEditLogEventTime &&
                    item.eventType === "Driving" &&
                    item.recordOrigin === "Auto" &&
                    item.recordStatus === "Active"
                ) {
                    i = key;
                }
            });

            return i;
        };

        if (historyLogs) {
            const historyByTime = _.sortBy(historyLogs, (o) =>
                moment(o.eventTime).valueOf()
            );

            let key = findHistoryBegin(dateTime, historyByTime);
            let driverHistory = historyByTime[key];

            // Walk backward to get the valid hos duty
            while (key && !isCalculationType(driverHistory)) {
                driverHistory = historyByTime[--key];
            }

            if (driverHistory) {
                if (driverHistory.hasOwnProperty("autoEventEndTimestamp")) {
                    autoDrivingEndTimestamp = moment(
                        driverHistory.autoEventEndTimestamp
                    );
                } else {
                    // Lets find the index of the auto driving event that didn't have
                    // the `autoEventEndTimestamp` and from it, we will determine the
                    // the autoEventEndTimestamp value by...
                    const index = historyLogs.findIndex((h) => h.id === driverHistory.id);

                    const historyCount = historyLogs.length;

                    // ...iterating through the collection of histories starting from the next event
                    // status from the determine auto driving event.
                    for (let i = index + 1; i < historyCount; i += 1) {
                        const historyLog = historyLogs[i];
                        if (
                            historyLog.recordStatus === "Active" &&
                            [
                                "OffDuty",
                                "Sleeper",
                                "Driving",
                                "OnDuty",
                                "WaitingAtSite",
                                "PowerOn",
                                "PowerOff",
                                "VbusDisconnectedRemark"
                            ].includes(historyLog.eventType)
                        ) {
                            autoDrivingEndTimestamp = moment(historyLog.eventTime);
                            break;
                        }
                    }
                }

                // Is driverHos an auto transition driving event?
                // Return whether selected timestamp is in between auto driving event
                if (
                    driverHistory.eventType === "Driving" &&
                    driverHistory.recordOrigin === "Auto"
                ) {
                    isBetweenAutoDrivingEvent =
                        moment(driverHistory.eventTime).isBefore(dateTime) &&
                        autoDrivingEndTimestamp.isAfter(dateTime);
                }
            }

            return isBetweenAutoDrivingEvent;
        }

        return isBetweenAutoDrivingEvent;
    },

    /**
     * Check if string is a json string.
     * @param str The string value to check.
     * return The boolean value.
     */
    isJsonString: function (str) {
        try {
            var o = JSON.parse(str);
            return (o && typeof o === "object" && o !== null);
        } catch (e) {
            return false;
        }
    },

    escapeHtml: function (text) {
        return text
            .replace("&amp;", "&")
            .replace("&lt;", "<")
            .replace("&gt;", ">")
            .replace("&#39;", "'")
            .replace("&#039;", "'");
    },

    /**
     * Convert an image to a base64 url
     * @param  Array{String} urls
     * @param  {Function} callback
     * @param  {String}   [outputFormat=image/png]
     */
    convertImgToBase64URL: function (urls, callback, outputFormat) {
        var i = 0,
            imgProcessed = 0,
            urlsLength = urls.length,
            dataURL = [],
            imgDom = [],
            url;

        for (; i < urlsLength; i += 1) {
            imgDom[i] = new Image();
            url = urls[i];

            imgDom[i].crossOrigin = 'use-credentials';

            imgDom[i].onload = function () {

                var canvas = document.createElement('CANVAS'),
                    ctx = canvas.getContext('2d');

                canvas.height = this.height;
                canvas.width = this.width;

                ctx.drawImage(this, 0, 0);
                dataURL[this.src] = canvas.toDataURL(outputFormat).replace(/^data:image\/(png|jpg);base64,/, "");

                //Revert to original, fixing dual accessing of pdf
                imgProcessed++;
                if (imgProcessed == urlsLength) {
                    callback(dataURL);
                }

                canvas = null;
            };

            imgDom[i].src = url;
        }
    },

    // MODEL HELPER METHODS
    ModelHelpers: {
        UserPreferences: {

            /**
             * Returns a formatted information of a certain user's preferences
             * @param   {object} data An object that holds the user-preferences datasouce and a user-id.
             * @returns {object} A formatted information of a certain user's preferences.
             */
            format: function (data) {
                "use strict";
                var filteredResults = _.filter(data.userPreference.serialize(), {
                        userId: data.userId
                    }),
                    preference = {
                        userId: "",
                        carrierDotNumber: "",
                        driverPhone: "",
                        hosExceptions: "",
                        firstName: "",
                        lastName: "",
                        carrierName: "",
                        mainOfficeStreet: "",
                        mainOfficeCity: "",
                        mainOfficeState: "",
                        mainOfficeZip: "",
                        homeTerminalStreet: "",
                        homeTerminalCity: "",
                        homeTerminalState: "",
                        homeTerminalZip: "",
                        homeTerminalCountry: "",
                        homeTerminalTimezone: "",
                        homeTerminalCode: "",
                        vehiclesDriven: "",
                        trailersUsed: "",
                        shipments: "",
                        startTimeOfDay: "",
                        region: "",
                        hosCycle: "",
                        hosCycleCa: "",
                        hosCycleUsa: "",
                        cdlNumber: "",
                        cdlIssuingDate: "",
                        unitOfDistance: "",
                        personalConveyance: "",
                        caUseOfDutyDeferral: "",
                        yardMoves: "",
                        pdfReceiverEmail: "",
                        cargo: "",
                    };

                _.forEach(filteredResults, (item) => {

                    // If value.stringVal is array, set its default value to empty and override it if it contains a value
                    if (can.isArray(item.stringVal)) {
                        item.stringVal = "";
                    }

                    preference.userId = item.userId;

                    switch (item.key) {
                        case "HOS_DRIVER_FIRST_NAME":
                            preference.firstName = item.stringVal;
                            break;
                        case "HOS_DRIVER_LAST_NAME":
                            preference.lastName = item.stringVal;
                            break;
                        case "HOS_CARRIER":
                            preference.carrierName = item.stringVal;
                            break;
                        case "HOS_MAIN_OFFICE_STREET":
                            preference.mainOfficeStreet = item.stringVal;
                            break;
                        case "HOS_MAIN_OFFICE_CITY":
                            preference.mainOfficeCity = item.stringVal;
                            break;
                        case "HOS_MAIN_OFFICE_STATE":
                            preference.mainOfficeState = item.stringVal;
                            break;
                        case "HOS_MAIN_OFFICE_ZIP":
                            preference.mainOfficeZip = item.stringVal;
                            break;
                        case "HOS_HOME_TERMINAL_STREET":
                            preference.homeTerminalStreet = item.stringVal;
                            break;
                        case "HOS_HOME_TERMINAL_CITY":
                            preference.homeTerminalCity = item.stringVal;
                            break;
                        case "HOS_HOME_TERMINAL_STATE":
                            preference.homeTerminalState = item.stringVal;
                            break;
                        case "HOS_HOME_TERMINAL_ZIP":
                            preference.homeTerminalZip = item.stringVal;
                            break;
                        case "HOS_HOME_TERMINAL_COUNTRY":
                            preference.homeTerminalCountry = item.stringVal;
                            break;
                        case "HOS_HOME_TERMINAL_TIMEZONE":
                            preference.homeTerminalTimezone = item.stringVal;
                            break;
                        case "HOS_HOME_TERMINAL_CODE":
                            preference.homeTerminalCode = item.stringVal;
                            break;
                        case "HOS_TRUCK_ID":
                            preference.vehiclesDriven = item.stringVal;
                            break;
                        case "HOS_TRAILER_ID":
                            preference.trailersUsed = item.stringVal;
                            break;
                        case "HOS_SHIPPING_DOCS_MANIFEST":
                            preference.shipments = item.stringVal;
                            break;
                        case "HOS_CARRIER_DOT_NUMBER":
                            preference.carrierDotNumber = item.stringVal;
                            break;
                        case "HOS_MAIN_OFFICE_PHONE":
                            preference.driverPhone = item.stringVal;
                            break;
                        case "HOS_START_TIME_OF_DAY":
                            preference.startTimeOfDay = item.stringVal;
                            break;
                        case "HOS_REGION":
                            preference.region = item.stringVal;
                            break;
                        case "HOS_CYCLE":
                            preference.hosCycle = item.stringVal;
                            break;
                        case "HOS_CYCLE_USA":
                            preference.hosCycleUsa = item.stringVal;
                            break;
                        case "HOS_CYCLE_CA":
                            preference.hosCycleCa = item.stringVal;
                            break;
                        case "HOS_EXCEPTIONS":
                            preference.hosExceptions = item.stringVal;
                            break;
                        case "HOS_CDL_NUMBER":
                            preference.cdlNumber = item.stringVal;
                            break;
                        case "HOS_CDL_ISSUING_STATE":
                            preference.cdlIssuingDate = item.stringVal;
                            break;
                        case "UNIT_OF_DISTANCE":
                            preference.unitOfDistance = item.stringVal;
                            break;
                        case "HOS_YARD_MOVES":
                            preference.yardMoves = item.stringVal;
                            break;
                        case "HOS_PERSONAL_CONVEYANCE":
                            preference.personalConveyance = item.stringVal;
                            break;
                        case "HOS_CA_USE_OFF_DUTY_DEFERRAL":
                            preference.caUseOfDutyDeferral = item.stringVal;
                            break;
                        case "HOS_CARGO":
                            preference.cargo = item.stringVal;
                            break;
                            // No default
                    }
                });

                return preference;
            }
        }
    }
};

// Source: https://scotch.io/tutorials/how-to-encode-and-decode-strings-with-base64-in-javascript
// Base64
Vistracks.Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

    encode: function (e) {
        "use strict";
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;

        e = this._utf8_encode(e);

        while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = (n & 3) << 4 | r >> 4;
            u = (r & 15) << 2 | i >> 6;
            a = i & 63;

            if (isNaN(r)) {
                u = a = 64
            } else if (isNaN(i)) {
                a = 64
            }

            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
        }

        return t;
    },

    decode: function (e) {
        "use strict";
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;

        e = e.replace(/[^A-Za-z0-9+/=]/g, "");

        while (f < e.length) {
            s = this._keyStr.indexOf(e.charAt(f++));
            o = this._keyStr.indexOf(e.charAt(f++));
            u = this._keyStr.indexOf(e.charAt(f++));
            a = this._keyStr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);

            if (u != 64) {
                t = t + String.fromCharCode(r)
            }

            if (a != 64) {
                t = t + String.fromCharCode(i)
            }
        }

        t = this._utf8_decode(t);

        return t;
    },

    _utf8_encode: function (e) {
        "use strict";
        e = e.replace(/rn/g, "n");
        var t = "";

        for (var n = 0; n < e.length; n++) {
            var r = e.charCodeAt(n);

            if (r < 128) {
                t += String.fromCharCode(r)
            } else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128);
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128);
            }
        }

        return t;
    },

    _utf8_decode: function (e) {
        "use strict";
        var t = "";
        var n = 0;
        var r = c1 = c2 = 0;

        while (n < e.length) {
            r = e.charCodeAt(n);

            if (r < 128) {
                t += String.fromCharCode(r);
                n++
            } else if (r > 191 && r < 224) {
                c2 = e.charCodeAt(n + 1);
                t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                n += 2;
            } else {
                c2 = e.charCodeAt(n + 1);
                c3 = e.charCodeAt(n + 2);
                t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                n += 3
            }
        }

        return t;
    }
};
